// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__NfAYT","loaderOuter":"PageOverlayLoader_loaderOuter__aBTM_"};